import React, { Component } from 'react';
import MaintenanceOverlay from './MaintenanceOverlay';
import { checkMaintenanceStatus, MAINTENANCE_POLL_INTERVAL_MS } from './checkMaintenanceStatus';

class MaintenanceGuard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maintenance: false,
    };
    this.intervalId = null;
  }

  componentDidMount() {
    this.refreshStatus();
    this.intervalId = setInterval(this.refreshStatus, MAINTENANCE_POLL_INTERVAL_MS);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.maintenance !== this.state.maintenance) {
      document.body.style.overflow = this.state.maintenance ? 'hidden' : '';
    }
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    document.body.style.overflow = '';
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      this.refreshStatus();
    }
  };

  refreshStatus = async () => {
    const maintenance = await checkMaintenanceStatus();
    if (maintenance !== this.state.maintenance) {
      this.setState({ maintenance });
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.props.children}
        {this.state.maintenance && <MaintenanceOverlay />}
      </React.Fragment>
    );
  }
}

export default MaintenanceGuard;
